import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface IdentityInterface {
  id: any;
}

@Injectable()
export abstract class DataStoreService<DataStoreModel> {

  _store$: BehaviorSubject<Map<number, DataStoreModel>>;
  _all$: Subject<DataStoreModel[]> = new Subject<DataStoreModel[]>();
  _inserts$: Subject<DataStoreModel> = new Subject<DataStoreModel>();
  _updates$: Subject<DataStoreModel> = new Subject<DataStoreModel>();
  _deletes$: Subject<DataStoreModel> = new Subject<DataStoreModel>();

  constructor() {
    this._store$ = new BehaviorSubject<Map<number, DataStoreModel>>(new Map<number, DataStoreModel>());
    this._store$.skip(1).subscribe((store) => {
      this._all$.next(Array.from(store.values()));
    });
  }

  all$(): Observable<DataStoreModel[]> {
    return this._all$;
  }

  inserts$(): Observable<DataStoreModel> {
    return this._inserts$;
  }

  deletes$(): Observable<DataStoreModel> {
    return this._deletes$;
  }

  updates$(): Observable<DataStoreModel> {
    return this._updates$;
  }

  find(id: number): DataStoreModel {
    let map = this._store$.getValue();
    return map.get(id);
  }

  insert(id: number, value: DataStoreModel) {
    let map = this._store$.getValue();
    map.set(id, value);
    this._inserts$.next(value);
    this._store$.next(map);
  }

  delete(id: number) {
    let map = this._store$.getValue();
    let item = map.get(id);
    map.delete(id);
    this._store$.next(map);
    this._deletes$.next(item);
  }

  update(model: IdentityInterface, updateAttributes: Object) {
    let id = model.id;
    let map = this._store$.getValue();
    let m = map.get(id);
    if (m) {
      Object.assign(m, updateAttributes);
      map.set(id, m);
      this._updates$.next(m);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/services/data-store.service.ts